import { t } from "@/i18n-js/instance";
import { BillingToggle } from "@/react/components/shared/BillingToggle";
import { useBillingCycleState } from "@/react/hooks/useBillingCycleState";

export const BillingCycleSwitch = () => {
  const { isYearly, shouldShowBillingCycleOptions, handleToggle } =
    useBillingCycleState();

  if (!shouldShowBillingCycleOptions) {
    return null;
  }

  return (
    <BillingToggle
      isAnnualPlan={isYearly}
      onChange={handleToggle}
      customText={t("pricing_plans.plan_settings.plan_summary.save_annually")}
    />
  );
};
